<template>
  <svg :class="['icon-chevron', direction]" :stroke="stroke" width="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.997 8.705"><path d="M11374,215.729l7.291,7.291-7.291,7.291" transform="translate(231.019 -11373.293) rotate(90)" fill="none" stroke="#1a1818" stroke-linecap="round" stroke-width="1"/></svg>
</template>

<script>
export default {
  name: 'IconChevron',
  props: {
    direction: {
      type: String,
      default: 'down',
      validator (value) {
        return ['up', 'down', 'left', 'right'].includes(value)
      }
    },
    color: {
      type: String,
      default: 'dark'
    }
  },
  computed: {
    stroke () {
      if (this.color === 'light') {
        return '#FFFFFF'
      } else {
        return '#1C1C1C'
      }
    }
  }
}
</script>

<style>
.icon-chevron.up {
  transform: rotate(180deg);
}

.icon-chevron.down {
  transform: rotate(0deg);
}

.icon-chevron.left {
  transform: rotate(90deg);
}

.icon-chevron.right {
  transform: rotate(270deg);
}
</style>
